import { useRef, useEffect } from 'react';

export const usePrevious = <P>(value?: P): P => {
    const ref = useRef<P>();

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
};
